/**
 * Adaptador para transformar los datos crudos de rendiciones a un formato adecuado para la tabla.
 * @param {Object} rawData - Datos crudos obtenidos de la API.
 * @returns {Object} Datos adaptados con las filas para la tabla.
 */
export const rendicionesAdapter = (rawData) => {
  const { data } = rawData;
  if (data?.comprobantes.length > 0) {
    const rows = data?.comprobantes.map((item) => {
      const {
        CAE,
        CUIT,
        DESCRIPCION,
        DESCRIPCION_CONCEPTO_GASTO,
        DESCRIPCION_TIPO_COMPROBANTE,
        FECHA,
        ID_DESCRIPCION_CONCEPTO_GASTO,
        ID_TIPO_COMPROBANTE,
        IMPORTE,
        NUMERO,
        ESTABLECIMIENTO,
        RAZON_SOCIAL,
        ID_FILE_COMPROBANTE,
      } = item;
      return {
        cae: CAE,
        cuit: CUIT,
        descripcion: DESCRIPCION,
        descripcionConceptoGasto: DESCRIPCION_CONCEPTO_GASTO,
        descripcionTipoComprobante: DESCRIPCION_TIPO_COMPROBANTE,
        fecha: FECHA,
        idDescripcionConceptoGasto: ID_DESCRIPCION_CONCEPTO_GASTO,
        idTipoComprobante: ID_TIPO_COMPROBANTE,
        importe: IMPORTE,
        importeFormateado: new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 2}).format(IMPORTE),
        numero: ESTABLECIMIENTO ? ESTABLECIMIENTO + '-' + NUMERO : '-',
        razonSocial: RAZON_SOCIAL,
        idFileComprobante: ID_FILE_COMPROBANTE,
      };
    });
    return { rows: rows, importeTotal: data.importe_total };
  }
  return { rows: [] };
};